import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-uikit/Form";
import { Button } from "../../uikit/Button";
import { RejectWithReasonTextArea } from "./RejectWithReasonTextArea";

interface RejectWithReasonActionsProps {
  contentType: "post" | "comment";
  i18nRoot: string;
  isRejecting?: boolean;
  onReject: (reason: string | null) => void;
}

export const RejectWithReasonActions = ({
  i18nRoot,
  onReject,
  isRejecting,
  contentType,
}: RejectWithReasonActionsProps) => {
  const [reason, setReason] = useState<string>();

  return (
    <div className="flex flex-col">
      <Form onSubmit={() => onReject(reason || null)}>
        <Form.Item
          name="reason"
          label={t([i18nRoot, "moderation_note"])}
          className="w-full !p-0"
          hideDescription
          hideBorder
        >
          <RejectWithReasonTextArea
            i18nRoot={i18nRoot}
            onReasonChange={setReason}
          />
        </Form.Item>
      </Form>
      <div className="mt-6 flex justify-end gap-4">
        <Button
          variant="danger"
          onClick={() => onReject(reason || null)}
          disabled={isRejecting}
        >
          {t([i18nRoot, `reject_${contentType}`])}
        </Button>
      </div>
    </div>
  );
};
